import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import Flex from '@wix/da-ds/pkg/Flex';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar/UserAvatar';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getProfileOwner } from '../../../../../selectors/users';

import s from './OriginalsPromoBanner.scss';

export interface Props {
  className?: string;
}

export const OriginalsPromoBanner: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { user } = useSelector(getProfileOwner);

  const originalsUrl = Url.userShopPath(
    user.username,
    USER_PROFILE_SHOP_SUB_PATHS.ORIGINALS
  );

  const biData = BiData<DefaultBiEvent>({
    evid: 2,
    click_info: 'discover_originals_promo',
    sectionname: 'exclusives',
  });

  return (
    <div className={classnames(s['root'], className)}>
      <Flex
        className={s['container']}
        direction="column"
        alignItems="center"
        gap={16}
      >
        <UserAvatar size={40} user={user} withLink={false} />

        <Flex direction="column" alignItems="center" gap={8}>
          <h3 className={s['title']}>
            {t('pages.shop.exclusives.originalsPromo.title')}
          </h3>
          <p className={s['subtitle']}>
            {t('pages.shop.exclusives.originalsPromo.subtitle')}
          </p>
        </Flex>

        <BiLink href={originalsUrl} biData={biData}>
          <BrandedButton size="medium" variant="originals-angular">
            {t('pages.shop.exclusives.originalsPromo.cta')}
          </BrandedButton>
        </BiLink>
      </Flex>
    </div>
  );
};

OriginalsPromoBanner.displayName = 'OriginalsPromoBanner';

export default OriginalsPromoBanner;
